export const fMpathConstants = {
  FMListingPath: '/filemanagement/list',
  FMCreatePath: '/filemanagement/create',
  FMEditPath: '/filemanagement/edit',
  FMDeletePath: '/filemanagement/delete',
  FMDownloadPath: '/filemanagement/download',
  FMUploadPath: '/filemanagement/upload',
  FMCategoryPath: '/filemanagement/category',
  FMSubCategoryPath: '/filemanagement/sub-category',
  FMListFoldersForPlant: '/filemanagement/listFoldersForPlant', 
  FMGetCategory: '/filemanagement/getCategory', 
}